'use client';

import { useTranslation } from '@/hooks/useTranslation';
import { useAuthGuard } from '@/hooks/useAuthGuard';
import { Button } from '@/components/ui/button';
import { ExternalLink, Loader2 } from 'lucide-react';

export default function KnowledgeBaseOutlinePage() {
  const { t } = useTranslation();
  const { isReady } = useAuthGuard();
  const outlineUrl = process.env.NEXT_PUBLIC_OUTLINE_URL || '';

  const handleOpenOutline = () => {
    if (!outlineUrl) {
      return;
    }

    window.open(outlineUrl, '_blank', 'noopener,noreferrer');
  };

  if (!isReady) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-64px)] bg-gray-50 px-6 py-6">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div>
              <h1 className="text-xl font-semibold text-gray-900">
                {t.knowledgeBase.outline.title}
              </h1>
              <p className="text-sm text-gray-500">{t.knowledgeBase.outline.subtitle}</p>
              <p className="mt-2 text-xs text-gray-400">{t.knowledgeBase.outline.embedHint}</p>
            </div>
            <Button
              variant="outline"
              onClick={handleOpenOutline}
              disabled={!outlineUrl}
            >
              <ExternalLink className="h-4 w-4" />
              <span className="ml-2">{t.knowledgeBase.outline.open}</span>
            </Button>
          </div>
        </div>

        <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          {outlineUrl ? (
            <iframe
              title={t.knowledgeBase.outline.iframeTitle}
              src={outlineUrl}
              className="h-[75vh] w-full rounded-lg border border-gray-100 bg-white"
            />
          ) : (
            <div className="flex items-center justify-center rounded-lg border border-dashed border-gray-200 px-6 py-16 text-sm text-gray-500">
              {t.knowledgeBase.outline.missingUrl}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
